class printsService {
    constructor($http, $q, $timeout) {
        'ngInject';

        this.$http = $http;
        this.$q = $q;
        this.$timeout = $timeout;
        this.printModes = [];
    }

    getPrices() {
        return this.$http.get(
            `/admpanel/ajax/configurator/prints/getPrices`
        );
    }

    getPrintModes() {
        const deferred = this.$q.defer();

        console.log('thisPrintModes', this.printModes);

        if (this.printModes.length > 0) {
            this.$timeout(() => {
                deferred.resolve(this.printModes);
            });
        } else {
            this.$http.get(
                `/ajax/configurator/prints/getPrintModes`
            ).then(
                response => {
                    this.printModes = response.data;
                    deferred.resolve(this.printModes);
                },
                response => {
                    deferred.reject();
                }
            );
        }

        return deferred.promise;
    }

    savePrices(prices) {
        for (const [printMode, printModeMultiplier] of Object.entries(prices.multipliers.print_mode)) {
            for (const [area, areaMultiplier] of Object.entries(prices.multipliers.area)) {
                if (typeof (prices.print_mode_area_price[printMode]) === 'undefined') {
                    prices.print_mode_area_price[printMode] = {};
                }
                if (typeof (prices.print_mode_area_price[printMode][area]) === 'undefined') {
                    prices.print_mode_area_price[printMode][area] = {};
                }
                prices.print_mode_area_price[printMode][area] = Math.round(parseFloat(prices.base) * parseFloat(printModeMultiplier) * parseFloat(areaMultiplier) * 100) / 100;
            }
        }

        return this.$http.post(
            `/admpanel/ajax/configurator/prints/savePrices`,
            prices
        );
    }
}

export default printsService;
